import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import {
    profile, // User profile configuration
    devConfig, // Development configuration settings
    countries, // List of countries for selection
    paymentSystem, // Payment system configuration (not used in this fragment)
    cashDesks, // Cash desks configuration (not used in this fragment)
    agentList, // List of agents (not used in this fragment)
} from 'config/config'; // Importing configuration settings from the config module

/**
 * Class representing the FilterProvidersView.
 * @extends JetView
 */
export default class FilterProvidersView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for translations
        const left = {
            margin: 5,
            id: 'a1',
            rows: [
                {
                    margin: 15,
                    css: 'on-row', // CSS class for styling
                    responsive: 'a1', // Responsive layout identifier
                    cols: [
                        {
                            view: 'text', // Text input for date selection
                            name: 'Datepicker',
                            id: 'Datepicker',
                            css: 'reportrange', // CSS class for styling
                            readonly: true, // Make the input read-only
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'), // Label with icon
                            labelPosition: 'top', // Position of the label
                            placeholder: _('Click para seleccionar '), // Placeholder text
                        },
                        {
                            view: 'datepicker', // Datepicker component
                            name: 'Date',
                            id: 'Date',
                            stringResult: true, // Return date as a string
                            minWidth: 200,
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'), // Label with icon
                            labelPosition: 'top', // Position of the label
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            value: moment().format('YYYY-MM-DD'), // Default value set to today's date
                            format: '%d %M %Y', // Date format
                            suggest: {
                                type: 'calendar', // Suggestion type
                                body: {
                                    maxDate: new Date(), // Maximum selectable date
                                },
                            },
                        },
                        {
                            view: 'richselect', // Rich select for country selection
                            name: 'CountrySelect',
                            id: 'CountrySelect',
                            label: "<span class='icon-language'></span>" + _('País'), // Label with icon
                            labelPosition: 'top', // Position of the label
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            options: {
                                body: {
                                    template: function (obj) {
                                        // Template for displaying country options
                                        return "<i class='flags " + obj.icon + "'></i>" + obj.value;
                                    },
                                    data: countries, // Data source for countries
                                },
                            },
                            // Conditional visibility based on configuration
                            hidden: devConfig.getCountryReport() || !devConfig.getPermAction('filterByCountry', 'Add'),
                            css: 'prm-filterByCountry', // CSS class for styling
                        },
                        {
                            view: 'richselect', // Second rich select for country selection
                            name: 'CountrySelect2',
                            label: "<span class='icon-language'></span>" + _('País'), // Label with icon
                            labelPosition: 'top', // Position of the label
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            value: profile.Settings.ReportCountry, // Default value from profile settings
                            readonly: true, // Make the input read-only
                            options: {
                                body: {
                                    template: function (obj) {
                                        // Template for displaying country options
                                        return "<i class='flags " + obj.icon + "'></i>" + obj.value;
                                    },
                                    data: countries, // Data source for countries
                                },
                            },
                            // Conditional visibility based on configuration
                            hidden: !devConfig.getCountryReport() || !devConfig.getPermAction('filterByCountry', 'Add'),
                            css: 'prm-filterByCountry country-hide', // CSS classes for styling
                        },
                    ],
                },
            ],
        };
        const left2 = {
            margin: 5,
            id: 'a8',
            rows: [
                {
                    margin: 15,
                    css: 'on-row', // CSS class for styling
                    responsive: 'a8', // Responsive layout identifier
                    cols: [
                        {
                            view: 'text', // Text input for names
                            name: 'Names',
                            minWidth: 200,
                            label: _('Nombres:'), // Label for names
                            labelPosition: 'top', // Position of the label
                            placeholder: _('Nombres'), // Placeholder text
                        },
                        {
                            view: 'text', // Text input for last names
                            name: 'Lastname',
                            minWidth: 200,
                            label: _('Apellidos:'), // Label for last names
                            labelPosition: 'top', // Position of the label
                            placeholder: _('Apellidos'), // Placeholder text
                        },
                        {
                            view: 'text', // Text input for phone number
                            name: 'Phone',
                            minWidth: 200,
                            label: _('Teléfono:'), // Label for phone
                            labelPosition: 'top', // Position of the label
                            placeholder: _('Teléfono'), // Placeholder text
                        },
                        {
                            view: 'text', // Text input for Skype ID
                            name: 'Skype',
                            minWidth: 200,
                            label: _('Skype:'), // Label for Skype
                            labelPosition: 'top', // Position of the label
                            placeholder: _('Skype'), // Placeholder text
                        },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row', // CSS class for styling
                    responsive: 'a8', // Responsive layout identifier
                    cols: [
                        {
                            view: 'text', // Text input for address
                            name: 'Address',
                            minWidth: 200,
                            label: _('Dirección:'), // Label for address
                            labelPosition: 'top', // Position of the label
                            placeholder: _('Dirección'), // Placeholder text
                        },
                        {
                            view: 'text', // Text input for email
                            name: 'Email',
                            minWidth: 200,
                            label: _('Email:'), // Label for email
                            labelPosition: 'top', // Position of the label
                            placeholder: _('Email'), // Placeholder text
                        },
                        {
                            view: 'text', // Text input for company name
                            name: 'Company',
                            minWidth: 200,
                            label: _('Empresa:'), // Label for company
                            labelPosition: 'top', // Position of the label
                            placeholder: _('Empresa'), // Placeholder text
                        },
                    ],
                },
            ],
        };
        const upper_section = {
            css: 'father-container', // CSS class for styling
            height: document.body.offsetWidth < 500 ? 190 : 0, // Conditional height based on screen width
            rows: [
                {
                    margin: 10,
                    cols: [left], // Left section containing filters
                },
            ],
        };
        const upper_section2 = {
            css: 'father-container', // CSS class for styling
            height: document.body.offsetWidth < 500 ? 130 : 0, // Conditional height based on screen width
            rows: [
                {
                    margin: 10,
                    cols: [left2], // Second left section containing additional filters
                },
            ],
        };
        const accordion_section = {
            id: 'b5',
            rows: [
                {
                    multi: true, // Allow multiple sections to be expanded
                    view: 'accordion', // Accordion component for collapsible sections
                    css: 'betShop', // CSS class for styling
                    collapsed: true, // Start collapsed
                    paddingY: 10,
                    type: 'clean', // Clean type for styling
                    rows: [
                        {
                            header: _('Filtros Avanzados'), // Header for advanced filters section
                            body: {
                                padding: 10,
                                rows: [upper_section2], // Content of the advanced filters section
                            },
                        },
                    ],
                },
            ],
        };
        const buttons = {
            id: 'b2',
            rows: [
                {
                    margin: 10,
                    responsive: 'b2', // Responsive layout identifier
                    cols: [
                        { id: 'grav', gravity: 4 }, // Gravity for layout adjustment
                        {
                            minWidth: 200,
                            view: 'button', // Button for clearing filters
                            value: _('Limpiar'), // Button label
                            width: screen == 'small' ? 0 : 100, // Conditional width based on screen size
                            click: () => {
                                this.getRoot().clear(); // Clear the form fields
                            },
                        },
                        {
                            minWidth: 200,
                            view: 'button', // Button for submitting filters
                            value: _('Consultar'), // Button label
                            type: 'form', // Button type
                            width: screen == 'small' ? 0 : 100, // Conditional width based on screen size
                            click: () => {
                                const filterdata = this.getRoot().getValues(); // Get values from the form
                                if (devConfig.getCountryReport()) {
                                    filterdata.CountrySelect = profile.Settings.ReportCountry; // Set country selection based on profile settings
                                }
                                delete filterdata['CountrySelect2']; // Remove unused field
                                if (profile.typeDate !== 2) {
                                    delete filterdata['Date']; // Remove date field if not applicable
                                } else {
                                    if (true) {
                                        delete filterdata['Datepicker']; // Remove datepicker if applicable
                                    }
                                }
                                this.app.callEvent('managementContact:filter', [
                                    filterdata, // Trigger filter event with collected data
                                ]);
                            },
                        },
                    ],
                },
            ],
        };
        const buttons2 = {
            padding: 10,
            cols: [
                {
                    view: 'button', // Button for clearing filters in the popup
                    value: _('Limpiar'), // Button label
                    click: () => {
                        $$('myForm2').clear(); // Clear the form fields in the popup
                    },
                },
                {
                    view: 'button', // Button for submitting filters in the popup
                    value: _('Consultar'), // Button label
                    type: 'form', // Button type
                    click: () => {
                        const filterdata = $$('myForm2').getValues(); // Get values from the popup form
                        if (devConfig.getCountryReport()) {
                            filterdata.CountrySelect = profile.Settings.ReportCountry; // Set country selection based on profile settings
                        }
                        delete filterdata['CountrySelect2']; // Remove unused field
                        if (profile.typeDate !== 2) {
                            delete filterdata['Date']; // Remove date field if not applicable
                        } else {
                            if (true) {
                                delete filterdata['Datepicker']; // Remove datepicker if applicable
                            }
                        }
                        this.app.callEvent('managementContact:filter', [
                            filterdata, // Trigger filter event with collected data
                        ]);
                        $$('filterPopup').hide(); // Hide the popup after submission
                    },
                },
            ],
        };
        const accordion_section2 = {
            type: 'wide', // Wide type for layout
            rows: [
                {
                    multi: true, // Allow multiple sections to be expanded
                    view: 'accordion', // Accordion component for collapsible sections
                    css: 'betShop', // CSS class for styling
                    collapsed: true, // Start collapsed
                    type: 'clean', // Clean type for styling
                    rows: [
                        {
                            header: _('Filtros'), // Header for filters section
                            id: 'b5',
                            body: {
                                padding: 10,
                                rows: [
                                    upper_section, // Content of the upper section
                                    accordion_section, // Advanced filters section
                                    buttons, // Buttons for actions
                                ],
                            },
                        },
                    ],
                },
            ],
        };
        const accordion_section3 = {
            view: 'scrollview', // Scrollable view for content
            scroll: 'xy', // Enable both horizontal and vertical scrolling
            body: {
                padding: 10,
                rows: [upper_section, accordion_section], // Content of the scrollable view
            },
        };
        const filterPopup = webix.ui({
            // Popup window for filters
            view: 'window',
            move: true, // Allow moving the window
            id: 'filterPopup',
            fullscreen: true, // Fullscreen mode
            head: {
                view: 'toolbar', // Toolbar for the popup header
                cols: [
                    { view: 'label', label: _('Filtros'), align: 'center' }, // Title label
                    {
                        view: 'icon', // Close icon for the popup
                        icon: 'wxi-close',
                        click: function () {
                            this.getTopParentView().hide(); // Hide the popup on click
                        },
                    },
                ],
            },
            modal: true, // Modal window
            position: 'center', // Center position on the screen
            body: {
                view: 'form', // Form inside the popup
                id: 'myForm2',
                type: 'clean', // Clean type for styling
                rows: [accordion_section3, buttons2], // Content of the form
                rules: {
                    fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
                },
            },
        });
        return {
            view: 'form', // Main form view
            type: 'clean', // Clean type for styling
            rows: [
                screen.width > 500 && screen.height > 500
                    ? accordion_section2 // Conditional rendering based on screen size
                    : { height: 1, width: 0 }, // Placeholder if conditions are not met
            ],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The grid component to initialize.
     */
    init(grid) {
        const lang = this.app.getService('locale').getLang(); // Get current language
        webix.ready(function () {
            if (profile.typeDate !== 2) {
                $$('Date').hide(); // Hide date input if typeDate is not 2
                $$('Datepicker').show(); // Show datepicker
            } else {
                if (true) {
                    $$('Date').show(); // Show date input if typeDate is 2
                    $$('Datepicker').hide(); // Hide datepicker
                }
            }
            $$('Datepicker').attachEvent('onAfterRender', function () {
                devConfig.setDateModal(lang); // Set date modal configuration after rendering
            });
        });
    }
}

// FILE DOCUMENTED
